// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const webserveruserClient = createTypedClient();
export const createWebserveruserClient = (config) => createTypedClient(config);
